<template>
  <div
    :class="{
      'inset-x-0 bottom-0': modelValue,
      'bottom-3 left-5 w-[calc(theme(width.full)-(theme(spacing.5)*3+theme(spacing.12)))] rounded-md': !modelValue,
    }"
    class="fixed z-[99] flex items-center gap-x-1.5 bg-[--v3-theme-primarycolor] px-4 py-3 transition-all"
    @click="handleClick"
  >
    <div class="flex size-control shrink-0 items-center justify-center rounded-[6px] bg-[--brand-forestgreenlight] text-white">
      <Icon name="star-solid" class="size-[18px]" />
    </div>
    <div v-if="list" class="flex min-w-0 flex-1 items-center gap-[8px] py-[4px] pl-[6px] pr-[8px]">
      <Icon
        name="solid-circle"
        :style="{
          color: list?.color
        }"
        class="size-[12px] shrink-0"
      />
      <span class="v3-body-regular-400-line-height-1.5 overflow-hidden truncate whitespace-nowrap text-[--v3-theme-primarytextcolor]">{{ list?.name }}</span>
      <span class="v3-body-regular-400-line-height-1.5 text-[--v3-theme-primarytextcolor] opacity-50">{{ list?.keywords.length }}</span>
    </div>
    <Icon
      v-if="list"
      :name="model? 'angle-down':'angle-up'"
      class="h-[11px] w-[20px] text-[--v3-theme-primarytextcolor] opacity-50"
    />
  </div>
</template>

<script lang="ts" setup>
import Icon from '@/common/components/atoms/Icon';

const model = defineModel<boolean>();

defineProps<{
  list: {
    id: number,
    name: string,
    color: string,
    keywords: {
      id: number,
      listId: number,
      keyword: string,
      flags?: string,
      notes?: string,
      tags?: number,
    }[]
  } | undefined | null,
}>();

const handleClick = () => {
  model.value = !model.value;
};
</script>

<style scoped>
/* Add your styles here */
</style>
